import { render, staticRenderFns } from "./ip-usage.vue?vue&type=template&id=ce79bd80&scoped=true"
import script from "./ip-usage.vue?vue&type=script&lang=js"
export * from "./ip-usage.vue?vue&type=script&lang=js"
import style0 from "./ip-usage.vue?vue&type=style&index=0&id=ce79bd80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce79bd80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VDataTable,VRow})
